import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const COMBINATIONS = [
  {
    code: "01",
    title: "PVRA + AR_ENA",
    text: "Für große Erlebnisstandorte, die Arena-Erlebnisse und sportlich-kompetitive Action in einer Location verbinden möchten.",
  },
  {
    code: "02",
    title: "Hotel VR + PINE Places",
    text: "Für Hotels, Resorts und touristische Betriebe, die Gästen vor Ort ein Inhouse-Erlebnis bieten und den Standort gleichzeitig digital als Markenraum erlebbar machen möchten.",
  },
  {
    code: "03",
    title: "PINE VR + PINE Places",
    text: "Für Eventlocations und kleinere Freizeitstandorte, die ein kompaktes Erlebnisangebot mit einer digitalen Customer Journey kombinieren möchten.",
  },
  {
    code: "04",
    title: "PVRA + PINE Places",
    text: "Für größere Standorte, die ihr Erlebnis nicht nur vor Ort betreiben, sondern online sichtbar, begehbar und erklärbar machen möchten.",
  },
];

export default function SystemCombinations() {
  return (
    <section
      className="border-t border-[rgba(255,255,255,0.08)] bg-[#0B0F10]"
      data-testid="system-combinations"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="overline mb-4">Systemkombination</div>
        <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] max-w-4xl">
          PINE Systems Produkte <br className="hidden md:block" />
          sind <span className="text-[#18E096]">kombinierbar.</span>
        </h2>
        <p className="text-[#AEB7B7] mt-6 max-w-3xl text-base md:text-lg leading-relaxed">
          Nicht jeder Standort braucht nur ein System. Je nach Fläche, Zielgruppe und
          Betreiberlogik können mehrere PINE Systems Profile kombiniert werden. So entstehen
          Erlebnisstandorte, die nicht aus Einzelprodukten bestehen, sondern aus einem passenden
          Systemmix.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px mt-12 border-l border-t border-[rgba(255,255,255,0.08)]">
          {COMBINATIONS.map((c) => (
            <div
              key={c.code}
              className="border-r border-b border-[rgba(255,255,255,0.08)] p-7 md:p-8 hover:bg-[#141819] transition-colors"
              data-testid={`combination-${c.code}`}
            >
              <div className="font-display text-3xl text-[#18E096]">{c.code}</div>
              <h3 className="font-display text-xl md:text-2xl uppercase mt-4 leading-tight">
                {c.title}
              </h3>
              <p className="text-[#AEB7B7] text-sm md:text-base mt-4 leading-relaxed">
                {c.text}
              </p>
            </div>
          ))}
        </div>

        <p className="text-white text-base md:text-lg mt-10 max-w-3xl leading-relaxed border-l-2 border-[#18E096] pl-5">
          Der passende Systemmix entsteht aus Standort, Zielgruppe und Journey.
        </p>

        <div className="mt-10">
          <Link
            to="/standort-pruefen"
            className="btn-primary"
            data-testid="combinations-cta"
          >
            Kombinationspotenzial prüfen <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </section>
  );
}
